var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverAllContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5C3.5 6.09987 3.5 5.3998 3.77248 4.86502C4.01217 4.39462 4.39462 4.01217 4.86502 3.77248C5.3998 3.5 6.09987 3.5 7.5 3.5H16.5C17.9001 3.5 18.6002 3.5 19.135 3.77248C19.6054 4.01217 19.9878 4.39462 20.2275 4.86502C20.5 5.3998 20.5 6.09987 20.5 7.5V16.5C20.5 17.9001 20.5 18.6002 20.2275 19.135C19.9878 19.6054 19.6054 19.9878 19.135 20.2275C18.6002 20.5 17.9001 20.5 16.5 20.5H7.5C6.09987 20.5 5.3998 20.5 4.86502 20.2275C4.39462 19.9878 4.01217 19.6054 3.77248 19.135C3.5 18.6002 3.5 17.9001 3.5 16.5V7.5Z",
    stroke: "#F05802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.5H6.26393C7.23426 8.5 7.71942 8.5 8.12999 8.69724C8.25717 8.75834 8.37753 8.83272 8.48906 8.91915C8.84909 9.19817 9.06606 9.63211 9.5 10.5V10.5C9.93394 11.3679 10.1509 11.8018 10.5109 12.0808C10.6225 12.1673 10.7428 12.2417 10.87 12.3028C11.2806 12.5 11.7657 12.5 12.7361 12.5H17.5C18.4319 12.5 18.8978 12.5 19.2654 12.3478C19.7554 12.1448 20.1448 11.7554 20.3478 11.2654C20.5 10.8978 20.5 10.4319 20.5 9.5V9.5",
    stroke: "#F05802"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H15",
    stroke: "#F05802",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverAllContracts);
export default __webpack_public_path__ + "static/media/OverAllContracts.01729ae519fd8130bf87a709b6824908.svg";
export { ForwardRef as ReactComponent };